export const buildInstagramUserUrl = (username: string | undefined) => {
    if (!username) {
        return '';
    }

    return `https://instagram.com/${username}`;
};

export const buildInstagramAudioUrl = (instagramId: string | number | undefined) => {
    if (!instagramId) {
        return '';
    }

    return `https://www.instagram.com/reels/audio/${instagramId}/`;
};
